import React from 'react'
import cx from 'classnames'
import config from 'config'
import { useDevice } from 'device'
import { useCityConfig, usePurchasedModules } from 'models/city'

import { Image, Text } from 'components/dataDisplay'

import { NewsBlock, WeatherWidget } from '../'

import s from './TopSection.scss'


type TopSectionProps = {
  className?: string
}

const getAreaType = (cityName: string): 'city' | 'area' | 'region' => {
  const areaTypes = {
    'Пуровский район': 'area', // район
    'Нижегородская область': 'region', // область
  }

  return areaTypes[cityName] || 'city'
}

const areaTitles = {
  'city': 'город',
  'area': 'район',
  'region': 'регион',
}

const areaTitlesPrepositional = {
  'city': 'городе',
  'area': 'районе',
  'region': 'регионе',
}

const textPlurals = {
  'city': 'городских',
  'area': 'районных',
  'region': 'регионных',
}

const TopSection: React.FC<TopSectionProps> = (props) => {
  const { className } = props

  const { cityConfig } = useCityConfig()
  const { purchasedModuleTags } = usePurchasedModules()
  const { isDesktop, isTablet, isMobile } = useDevice()

  const isWithNews = purchasedModuleTags?.includes('NEWS')

  const prefix = __DEV__ ? '/proxy' : ''
  const imageFromSettings = cityConfig?.designOptions?.mainPageImage
  const mainPageImageUrl = (imageFromSettings && prefix + imageFromSettings)
   || `${config.storage}/common/mainPageImage.jpg`

  const areaType = getAreaType(config.cityName)

  const title = `Вместе сделаем ${areaTitles[areaType]} лучше`

  const text = areaType === 'region'
    ? `
      Платформа «Умный регион» позволяет быть в курсе актуальных событий и участвовать в 
      развитии Нижегородской области.
    `
    : `
      Cообщайте о проблемах, решайте судьбу ${textPlurals[areaType]} инициатив и получайте
      самую актуальную информацию о происходящем в ${areaTitlesPrepositional[areaType]}
    `

  const secondaryText = areaType === 'region'
    ? `
      На сайте своего округа вы можете сообщить о проблемах, решить судьбу городских инициатив и 
      получать самую актуальную информацию о происходящем в округе.
    `
    : null

  return (
    <div className={cx(className, 'relative')}>
      <div
        className={cx(s.textContainer, { [s.withNews]: isWithNews, 'flex flex-col justify-center': !isWithNews })}
      >
        <Text
          message={title}
          size={isMobile ? 'h32' : isTablet ? 'h40' : 'h56'}
          color="titanic"
        />
        <Text
          className="mt-24px"
          message={text}
          size="t16-24"
          color="gladiator"
        />
        {
          Boolean(secondaryText) && (
            <Text
              className="mt-24px"
              message={secondaryText}
              size="t16-24"
              color="gladiator"
            />
          )
        }
        {
          isWithNews && !isMobile && (
            <NewsBlock className="mt-40px" />
          )
        }
      </div>
      <div
        className={cx(s.imageContainer, {
          'absolute overflow-hidden': !isMobile,
          'flex relative': isMobile,
        })}
      >
        {
          purchasedModuleTags?.includes('WEATHER') && (
            <WeatherWidget className={cx(s.weather, 'z-1', isMobile ? 'mt-32px' : 'absolute left-0')} />
          )
        }
        <div
          className={cx(s.image, isMobile ? 'absolute overflow-hidden' : null, { [ s.withoutWeather ]: !purchasedModuleTags?.includes('WEATHER') })}
        >
          <Image
            src={mainPageImageUrl}
            // width={isMobile ? '408' : isDesktop ? '688' : '541'}
            aspect={1.3129}
            height={isMobile ? '311' : isDesktop ? '524' : '412'}
          />
        </div>
      </div>
      {
        isWithNews && isMobile && (
          <NewsBlock className="mt-40px" />
        )
      }
    </div>
  )
}


export default TopSection
